<script>
import QuoteSlider from './Part/QuoteSlider.vue';

export default {
    components: {
        QuoteSlider
    },
    data() {
        return {
            data: {},
        };
    },
    methods: {
        create() {
            var vm = this;

            vm.createEmptyData();
        },
        createEmptyData() {
            var vm = this;

            var data = {
                email: null,
            };

            vm.data = Object.assign({}, data);
        },
        _createPostData(data) {
            return data;
        },
        async submit() {
            var vm = this;

            try {
                vm.$loading.on('forgot_password_submit');

                var data = vm._createPostData(vm.data);

                var resp = await vm.$api.Auth.forgotPassword(data);
                vm.$router.push({ name: 'login' });

                vm.$flash.success(resp.data.message);
            } catch (error) {
                vm.$flash.error(error.response.data.message);
            }

            vm.$loading.off('forgot_password_submit');
        },
    }
};
</script>

<template>
    <div class="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
        <div class="bg-overlay"></div>
        <div class="auth-page-content overflow-hidden pt-lg-5">
            <BContainer>
                <BRow>
                    <BCol lg="12">
                        <BCard no-body class="overflow-hidden">
                            <BRow class="justify-content-center g-0">
                                <BCol lg="6">
                                    <QuoteSlider />
                                </BCol>

                                <BCol lg="6">
                                    <div class="p-lg-5 p-4">
                                        <h5 class="text-primary">{{ $t('forgot_password.title.form') }}</h5>
                                        <p class="text-muted">{{ $t('forgot_password.label.sub_title') }}</p>

                                        <BAlert :model-value="true" variant="warning"
                                            class="mb-2 mx-2 border-0 text-center">{{
                                                $t('forgot_password.label.instruction') }}</BAlert>

                                        <div class="p-2">
                                            <b-form @submit="submit()">
                                                <div class="mb-4">
                                                    <label class="form-label">{{ $t('forgot_password.label.email')
                                                        }}</label>
                                                    <input type="text" class="form-control" id="email"
                                                        v-model="data.email"
                                                        :placeholder="$t('forgot_password.placeholder.email')">
                                                </div>

                                                <div class="text-center mt-4">
                                                    <BButton variant="primary" class="w-100" type="submit"
                                                    :disabled="$loading.get('forgot_password_submit')">
                                                        <loading
                                                            :loading="$loading.get('forgot_password_submit')">
                                                            {{ $t('forgot_password.btn.send') }}
                                                        </loading>
                                                    </BButton>
                                                </div>
                                            </b-form>
                                        </div>

                                        <div class="mt-5 text-center">
                                            <p class="mb-0">{{ $t('forgot_password.label.signin') }} <router-link
                                                    :to="{ name: 'login' }"
                                                    class="fw-semibold text-primary text-decoration-underline"> {{
                                                    $t('forgot_password.btn.signin') }} </router-link>
                                            </p>
                                        </div>
                                    </div>
                                </BCol>
                            </BRow>
                        </Bcard>
                    </BCol>

                </BRow>
            </BContainer>
        </div>

        <footer class="footer">
            <BContainer>
                <BRow>
                    <BCol lg="12">
                        <div class="text-center">
                            <p class="mb-0">&copy; 2026 Cafeman. Seluruh Hak Cipta Dilindungi.</p>
                        </div>
                    </BCol>
                </BRow>
            </BContainer>
        </footer>
    </div>
</template>